import { UI_CODE } from '@/common/resources/const'
import { beforeGNBEnter } from '@/common/utils/common'
import {
  PATH_NAME_BROADCAST,
  PATH_NAME_GLOBAL,
  PATH_NAME_HOME,
  PATH_NAME_LIVE,
  PATH_NAME_MOVIE,
} from '@/common/resources/router.const'

export default [
  {
    path: 'home',
    name: PATH_NAME_HOME,
    meta: { uiCode: UI_CODE.HOME, section: PATH_NAME_HOME },
    alias: 'home/index.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "home" */ '@/pages/index'),
    },
    beforeEnter: beforeGNBEnter,
  },
  {
    path: 'vod',
    name: PATH_NAME_BROADCAST,
    meta: { uiCode: UI_CODE.BROADCAST, section: PATH_NAME_BROADCAST },
    alias: '/vod/index.html',
    components: {
      bodyContent: () => import(/* webpackChunkName: "vod" */ '@/pages/vod'),
    },
    beforeEnter: beforeGNBEnter,
  },
  {
    path: 'live',
    name: PATH_NAME_LIVE,
    meta: { uiCode: UI_CODE.LIVE, section: PATH_NAME_LIVE },
    alias: '/live/index.html',
    components: {
      bodyContent: () =>
        import(/* webpackChunkName: "live" */ '@/pages/live/new'),
    },
    beforeEnter: beforeGNBEnter,
  },
  {
    path: 'movie',
    name: PATH_NAME_MOVIE,
    meta: { uiCode: UI_CODE.MOVIE, section: PATH_NAME_MOVIE },
    alias: '/movie/index.html',
    components: {
      bodyContent: () =>
        import(/* webpackChunkName: "movie" */ '@/pages/movie'),
    },
    beforeEnter: beforeGNBEnter,
  },
  {
    path: 'global',
    name: PATH_NAME_GLOBAL,
    meta: { uiCode: UI_CODE.GLOBAL, section: PATH_NAME_GLOBAL },
    alias: '/global/index.html',
    components: {
      bodyContent: () =>
        import(/* webpackChunkName: "global" */ '@/pages/global'),
    },
    beforeEnter: beforeGNBEnter,
  },
]
